import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here

import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@material-ui/core';
import Localization from '../../Localization';

class KLAList extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hasLabel: false,
    };
    autoBind(this);

    if (this.props.hasLabel) {
      this.state.hasLabel = this.props.hasLabel;
    }
  }

  onKLAChanged(e) {
    if (this.props.parent.onKLAChanged) {
      this.props.parent.onKLAChanged(e);
    }
  }

  render() {
    return (
      <FormControl>
        <If condition={this.state.hasLabel}>
          <Then>
            <InputLabel>{Localization.strings.KLA}</InputLabel>
          </Then>
        </If>
        <Select
          value={this.props.kla}
          onChange={this.onKLAChanged}
        >
          <MenuItem key={0} value={0}>{Localization.strings.SELECT_KLA}</MenuItem>
          <MenuItem key={1} value={1}>{Localization.strings.CROSS_KLA}</MenuItem>
          <MenuItem key={2} value={2}>{Localization.strings.CHINESE_LANGUAGE}</MenuItem>
          <MenuItem key={3} value={3}>{Localization.strings.ENGLISH_LANGUAGE}</MenuItem>
          <MenuItem key={4} value={4}>{Localization.strings.MATHEMATICS}</MenuItem>
          <MenuItem key={5} value={5}>{Localization.strings.SCIENCE}</MenuItem>
          <MenuItem key={6} value={6}>{Localization.strings.TECHNOLOGY}</MenuItem>
          <MenuItem key={7} value={7}>{Localization.strings.P_S_H_E}</MenuItem>
          <MenuItem key={8} value={8}>{Localization.strings.ARTS}</MenuItem>
          <MenuItem key={9} value={9}>{Localization.strings.P_E}</MenuItem>
        </Select>
      </FormControl>
    )
  }
}

export default KLAList;
